import KendraPluginTypes from './kendraPlugin.types';
import KendraPluginState from './kendraPlugin.state';
import AnyAction from 'store/anyActions';

const defaultState: KendraPluginState = {
    searchText: '',
    selected: undefined,
    filters: {},
    documents: [],
};

export default function (state: KendraPluginState = defaultState, action: AnyAction): KendraPluginState {
    switch (action.type) {
        case KendraPluginTypes.SET_KENDRA_PLUGIN_STATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}